export var _AMBER18 = '#FAD08A';
var _BLUE = '#428BCA';
var _DARK_BLUE = '#2A6496';
var _PALE_BLUE = '#EAEDFF';
export var _BLUE19 = '#D0E4FF';
var _BLUE40 = '#0055D3';
var _BLUE_45 = '#0060EB';
var _DARK_DARK_BLUE = '#293846';
var _HOVER_LINK_BLUE = 'rgba(0, 126, 255, 0.08)';
var _GREEN = '#30AE1E';
export var _GREEN17 = '#7BDCAE';
var _DARK_GREEN = '#12A000';
var _YELLOW = '#F89406';
var _DARK_YELLOW = '#c17100';
var _PINK = 'pink';
export var _LIGHT_RED = '#FC8888';
var _RED = '#FF0000';
export var _RED16 = '#F6A5AB';
var _DARK_RED = '#CC0000';
export var _TURQUOISE = '#23c6c8';
var _DARK_TURQUOISE = '#21b9bb';
var _BLACK = '#000000';
var _ALMOST_BLACK = '#4a4a4a';
var _BLACK40 = 'rgba(0,0,0,0.4)';
var _DARK_GREY = '#5F5F5F';
export var _DARKEST_GREY = '#515151';
var _MEDIUM_DARK_GREY = '#BABABA';
var _MEDIUM_GREY = '#C2C2C2';
export var _GREY = '#aaa';
export var _LIGHT_GREY = '#EAEAEA';
var _VERY_LIGHT_GREY = '#F9F9F9';
var _DISABLED_BUTTON_GREY = '#F3F3F4';
var _GREY20 = '#2D3038';
var _GREY45 = '#656A7A';
var _GREY65 = '#7D8396';
var _GREY70 = '#A6ABB9';
var _GREY85 = '#D2D4DB';
var _GREY100 = '#F6F6F8';
var _ALMOST_WHITE = '#fff';
export var _WHITE = '#FFFFFF';
var _MOUNTAIN_MEADOW = '#1AB394';
var _MOUNTAIN_MEADOW_2 = '#18a689';
var _GEISER = '#d1dade';
var _PORCELAIN = '#e7eaec';
var _ALTO = '#d2d2d2';
var _SCORPION = '#5e5e5e';
var _MANDY = '#ed5565';
var _CADET_BLUE = '#a7b1c2';
var _SEARCH_TEXT_BLUE = '#246fa4';
var _ALIZARIN_CRIMSON = '#e62623';
var _APPLE = '#3EB735';
var _CERULEAN_BLUE = '#2457c5';
var _CURIOUS_BLUE = '#2F8AC9';
var _DOVE_GRAY = '#323847';
var _DOVE_GRAY2 = '#6a6a6a';
var _FERN_FROND = '#4f751d';
var _GALLERY = '#EEEEEE';
export var _GALLERY2 = '#E9EBF0';
var _GRAY = '#848484';
export var _GUARDSMAN_RED = '#F6A5AB';
var _INDOCHINE = '#C46E00';
export var _INDOCHINE2 = '#FAD08A';
export var _LIMEADE = '#7BDCAE';
var _LINK_WATER = '#DDECFE';
var _LOAFER = '#004120';
var _MANGO_TANGO = '#d77900';
var _MARINER = '#0064E1';
var _MARINER_HOVER = '#0044AB';
var _MINE_SHAFT = '#303030';
var _MINE_SHAFT2 = '#262626';
var _PEACH_CREAM = '#FFEAE0';
var _PEACH_CREAM2 = '#592D00';
var _PIPPIN = '#770018';
var _SCIENCE_BLUE = '#0065DD';
var _SILVER_CHALICE = '#b0b0b0';
var _STAR_DUST = '#A1A1A1';
var _STEEL_05 = '#323847';
var _STEEL_18 = '#D2D6E1';
export var _STEEL_21 = '#F5F6F8';
var _TORY_BLUE = '#144bb4';
var _TUNA = '#333843';
export var _VIOLET_15 = '#DE93D5';
var _ZIRCON = '#f4f6ff';
export var _ab_color = {
  blue: _MARINER,
  hoverBlue: _MARINER_HOVER,
  darkBlue: '#3B5998',
  hoverDarkBlue: '#1C3C68',
  lightGrayHeader: '#F6F6F6',
  lightBlue: '#50B2E9',
  smallIconBlue: '#3A84C1A6',
  grey: '#515151',
  hoverGrey: '#3A3A3A',
  red: '#FF0000',
  hoverRed: '#CC0000',
  borderRed: 'rgba(231,19,19,0.4)',
  boxShadowRed: _MANDY,
  green: '#30AE1E',
  hoverGreen: '#12A000',
  lightGrey: '#CCC',
  backgroundGrey: '#F3F3F4',
  backgroundLightGrey: '#F9F9F9',
  mediumGrey: '#C2C2C2',
  darkGrey: '#666666',
  yellow: '#F89406',
  black: '#000000',
  orange: 'orange',
  textColor: '#676A6C'
};
export var ecommerceColors = {
  background: _STEEL_21,
  blue: '#428BCA',
  border: _STEEL_18,
  disabled: _MEDIUM_GREY,
  green: '#007868',
  grey: '#D2D6E1',
  lightBlue: '#D3E4FB',
  link: '#0064E1',
  peach: '#FCCE9E',
  promotion_text: '#008574',
  red: '#DD3249',
  sub_text: '#606A84',
  text: _STEEL_05,
  turquoise: '#8DD6C7',
  white: '#FFFFFF'
};
export var BLUE_PRIMARY = _MARINER;
export var BLUE_SECONDARY = _MARINER_HOVER;
export var BACKGROUND_COLOR = _VERY_LIGHT_GREY;
export var FOREGROUND_COLOR = _WHITE;
export var DARKER_BORDER_COLOR = _MEDIUM_DARK_GREY;
export var BORDER_COLOR = _LIGHT_GREY;
export var PRIMARY_BACKGROUND = _BLUE;
export var SECONDARY_BACKGROUND = _LIGHT_GREY;
export var BLUE_FILTER_BACKGROUND = _DARK_DARK_BLUE;
export var FILTER_GREEN = _GREEN;
export var FILTER_HOVER = _DARK_GREEN;
export var SELECTED_COLOR = _BLUE;
export var HOVER_LINK_BLUE_COLOR = _HOVER_LINK_BLUE;
export var PRIMARY_BUTTON_COLOR = _BLUE;
export var PRIMARY_BUTTON_HOVER_COLOR = _DARK_BLUE;
export var SECONDARY_BUTTON_COLOR_1 = _MEDIUM_GREY;
export var SECONDARY_BUTTON_COLOR_2 = _DARK_GREY;
export var SECONDARY_BUTTON_DISABLED_2 = _MEDIUM_GREY;
export var SECONDARY_BUTTON_HOVER_COLOR_1 = _MEDIUM_DARK_GREY;
export var SECONDARY_BUTTON_HOVER_COLOR_2 = _BLACK;
export var TERTIARY_BUTTON_COLOR = _TURQUOISE;
export var TERTIARY_BUTTON_HOVER_COLOR = _DARK_TURQUOISE;
export var REMOVE_BUTTON_COLOR = _RED;
export var REMOVE_BUTTON_HOVER_COLOR = _DARK_RED;
export var ACCEPT_BUTTON_COLOR = _GREEN;
export var ACCEPT_BUTTON_HOVER_COLOR = _DARK_GREEN;
export var WARNING_BUTTON_COLOR = _YELLOW;
export var WARNING_BUTTON_HOVER_COLOR = _DARK_YELLOW;
export var PAGE_COLOR = _BLACK;
export var PRIMARY_TEXT_COLOR = _WHITE;
export var SECONDARY_TEXT_COLOR = _BLACK;
export var UNIMPORTANT_TEXT = _MEDIUM_GREY;
export var DISABLED_TEXT = _MEDIUM_GREY;
export var LABEL_TEXT = _DARK_GREY;
export var PLACEHOLDER_TEXT = _GREY;
export var REQUIRED_TEXT = _RED;
export var BAD_STATE = _RED;
export var CANCELLED_STATE = _LIGHT_RED;
export var DISABLED_INPUT_STATE = _VERY_LIGHT_GREY;
export var DISABLED_STATE = _MEDIUM_GREY;
export var DISABLED_BUTTON_STATE = _DISABLED_BUTTON_GREY;
export var ERROR_STATE = _PINK;
export var GOOD_STATE = _GREEN;
export var ACCEPTED_STATE = _DARK_GREEN;
export var NORMAL_STATE = _BLUE;
export var NORMAL_STATE_2 = _DARK_BLUE;
export var REJECTED_STATE = _DARK_RED;
export var REVIEW_STATE = _TURQUOISE;
export var WARNING_STATE = _YELLOW;
export var SEARCH_BLUE_COLOR = _MARINER;
export var SEARCH_SECONDARY_COLOR = '#386FF0';
export var SEARCH_TOGGLER_COLOR = _MARINER;
export var SEARCH_FOCUS_UNCHECKED_COLOR = '#D4D4D4';
export var SEARCH_FOCUS_CHECKED_COLOR = '#CAD2FF';
export var SEARCH_ACTIVE_BACKGROUND_COLOR = '#2457C5';

// Link
export var LINK_DEFAULT_COLOR = '#0064E1';
export var LINK_HOVER_COLOR = '#386FF0';
export var LINK_ACTIVE_COLOR = '#2457C5';

// Link Button
export var LINK_BUTTON_ACTIVE_COLOR = '#EAEDFF';

// Button
export var SEARCH_PRIMARY_DEFAULT_COLOR = '#FFFFFF';
export var SEARCH_PRIMARY_DEFAULT_BACKGROUND_COLOR = '#0064E1';
export var SEARCH_PRIMARY_FOCUS_BORDER_COLOR = '#CAD2FF';
export var SEARCH_PRIMARY_HOVER_BACKGROUND_COLOR = '#386FF0';
export var SEARCH_PRIMARY_ACTIVE_BACKGROUND_COLOR = '#2457C5';
export var SEARCH_PRIMARY_BORDER_COLOR = '#0064E1';
export var SEARCH_SECONDARY_DEFAULT_COLOR = '#262626';
export var SEARCH_SECONDARY_DEFAULT_BACKGROUND_COLOR = '#fff';
export var SEARCH_SECONDARY_FOCUS_BORDER_COLOR = '#D4D4D4';
export var SEARCH_SECONDARY_HOVER_BACKGROUND_COLOR = '#FFFFFF';
export var SEARCH_SECONDARY_ACTIVE_BACKGROUND_COLOR = '#E2E2E2';
export var MODAL_BUTTON_SECONDARY_BORDER_COLOR = '#D4D4D4';
export var SEARCH_PAGE_BACKGROUND = '#fff';
export var SEARCH_PANEL_BACKGROUND = '#fff';
export var SEARCH_PANEL_HEADER_COLOR = _MARINER;
export var BUTTON_BACKGROUND_COLOR = '#f6f6f6';
export var BUTTON_TEXT_COLOR = _SEARCH_TEXT_BLUE;
export var BUTTON_BORDER_COLOR = BUTTON_TEXT_COLOR;
export var EWALLET_PRIMARY_FIELD_TEXT = _GREY20;
export var EWALLET_SUBFIELD_TEXT = _GREY45;
export var EWALLET_ERROR_TEXT = _GREY65;
export var EWALLET_MONEY_TEXT = _BLUE_45;
export var EWALLET_RADIO_BUTTON_BORDER = _GREY70;
export var EWALLET_RADIO_BUTTON_BACKGROUND = _GREY100;
export var EWALLET_RADIO_SELECTED_TEXT = _BLUE40;
export var EWALLET_CARD_BORDER = _GREY85;
export var INPUT_BACKGROUND_COLOR = _WHITE;
export var INPUT_BORDER_COLOR = _DOVE_GRAY2;
export var INPUT_CHECKBOX_COLOR = _MARINER;
export var INPUT_FOCUS_COLOR = '#2684ff';
export var INPUT_SWITCH_COLOR = '#3aa5f0';
export var BUTTON_DISABLED_TEXT_COLOR = BUTTON_TEXT_COLOR;
export var BUTTON_DISABLED_BACKGROUND_COLOR = BUTTON_BACKGROUND_COLOR;
export var BUTTON_DEFAULT_COLOR = _WHITE;
export var BUTTON_DEFAULT_BACKGROUND_COLOR = BUTTON_TEXT_COLOR;
export var SCHOOL_SEARCH_HEADER_COLOR = _ALMOST_BLACK;
export var SCHOOL_SEARCH_SCHOOL = _ALMOST_BLACK;
export var SEARCH_RESULTS_BACKGROUND_COLOR = _ALMOST_WHITE;
export var SEARCH_RESULTS_SCHOOL_BORDER = _SILVER_CHALICE;
export var SEARCH_HEADER_BUTTON = _MARINER;
export var TAB_ITEM_BACKGROUND = 'transparent';
export var TAB_DISABLED_TEXT = '#666666';
export var TAB_ACTIVE_TEXT = _MARINER;
export var TAB_ITEM_SELECTED_BACKGROUND = _ALMOST_WHITE;
export var TAB_ITEM_SELECTED_BORDER_COLOR = _MARINER;
export var SEARCH_BUTTON_BACKGROUND = _MARINER;
export var SEARCH_BASE_TEXT = _MINE_SHAFT;
export var SEARCH_PROGRAM_TEXT = _CURIOUS_BLUE;
export var SEARCH_EMPTY_STATE_BUTTON_BACKGROUND = _ZIRCON;
export var SEARCH_EMPTY_STATE_BUTTON_BORDER = _CERULEAN_BLUE;
export var SEARCH_EMPTY_STATE_BUTTON_TEXT = _TORY_BLUE;
export var SEARCH_INPUT_PLACEHOLDER = _GRAY;
export var SEARCH_INPUT_TEXT = _MINE_SHAFT2;
export var SEARCH_PROGRAM_LIST_DIVIDER = '#D4D4D4';
export var SEARCH_PROGRAM_DETAILS_TEXT = _MINE_SHAFT;
export var SEARCH_PROGRAM_DETAILS_COMMISSION = _FERN_FROND;
export var SEARCH_OPTION_FOCUSED_BACKGROUND_COLOR = _GALLERY;
export var SEARCH_OPTION_FOCUSED_COLOR = _MINE_SHAFT2;
export var SEARCH_OPTION_SELECTED_BACKGROUND_COLOR = _PALE_BLUE;
export var SEARCH_OPTION_SELECTED_COLOR = _MARINER;
export var SEARCH_ELIGIBILITY_WARNING_TEXT = _INDOCHINE;
export var SEARCH_ELIGIBILITY_WARNING_BACKGROUND = _PEACH_CREAM;
export var SELECT_STUDENT_MODAL_MISSING = _PEACH_CREAM2;
export var SELECT_STUDENT_MODAL_MISSING_BACKGROUND = _INDOCHINE2;
export var SELECT_STUDENT_MODAL_INELIGIBLE = _PIPPIN;
export var SELECT_STUDENT_MODAL_INELIGIBLE_BACKGROUND = _GUARDSMAN_RED;
export var SELECT_STUDENT_MODAL_APPLIED = _DOVE_GRAY;
export var SELECT_STUDENT_MODAL_APPLIED_BACKGROUND = _GALLERY2;
export var SELECT_STUDENT_MODAL_ELIGIBLE = _LOAFER;
export var SELECT_STUDENT_MODAL_ELIGIBLE_BACKGROUND = _LIMEADE;
export var FIELD_BORDER_DIRTY = _MANGO_TANGO;
export var FIELD_BORDER_INVALID = _ALIZARIN_CRIMSON;
export var BUTTON_COLLECTION_BACKGROUND = _MOUNTAIN_MEADOW;
export var BUTTON_COLLECTION_BACKGROUND_HOVER = _MOUNTAIN_MEADOW_2;
export var BUTTON_COLLECTION_DISABLED_BACKGROUND = _MEDIUM_GREY;
export var BUTTON_COLLECTION_DISABLED_BORDER = _GEISER;
export var BUTTON_PILL_BORDER = _PORCELAIN;
export var BUTTON_PILL_SELECTED_BOXSHADOW = _BLACK40;
export var BUTTON_PILL_HOVER_BORDER = _ALTO;
export var BADGE_DEFAULT_TEXT = _SCORPION;
export var BADGE_DEFAULT_BACKGROUND = _GEISER;
export var BADGE_DANGER_TEXT = _WHITE;
export var BADGE_DANGER_BACKGROUND = _MANDY;
export var TAB_SELECTOR_BORDER = _PORCELAIN;
export var TAB_SELECTOR_BORDER_HIDDEN = _WHITE;
export var TAB_TEXT_UNSELECTED = _CADET_BLUE;
export var TAB_TEXT_SELECTED = _BLACK;
export var TAB_CONTENT_BACKGROUND = _WHITE;
export var VIEW_BUTTON_BACKGROUND = _MOUNTAIN_MEADOW;
export var VIEW_BUTTON_HOVER_BACKGROUND = _MOUNTAIN_MEADOW_2;
export var SUCCESS_GREEN = _APPLE;
export var CLOSE_BUTTON_COLOR = _MEDIUM_DARK_GREY;
export var STUDENT_DASHBOARD_TITLE_COLOR = '#323847';
export var STUDENT_DASHBOARD_SECONDARY_TEXT_COLOR = '#606A84';
export var STUDENT_DASHBOARD_LINK_COLOR = _MARINER;
export var STUDENT_DASHBOARD_BORDER_COLOR = '#D2D6E1';
export var STUDENT_DASHBOARD_NEGATIVE_COLOR = '#F4A6AB';
export var STUDENT_DASHBOARD_NEUTRAL_COLOR = '#E9EBF0';
export var STUDENT_DASHBOARD_POSITIVE_COLOR = '#8DD6C7';
export var STUDENT_DASHBOARD_ACTION_COLOR = '#D3E4FB';
export var STUDENT_DASHBOARD_ACTION_TEXT_COLOR = '#2B346C';
export var STUDENT_DASHBOARD_NEUTRAL_TEXT_COLOR = STUDENT_DASHBOARD_TITLE_COLOR;
export var STUDENT_DASHBOARD_NEGATIVE_TEXT_COLOR = '#6F1420';
export var STUDENT_DASHBOARD_POSITIVE_TEXT_COLOR = '#004037';
export var STUDENT_DASHBOARD_BUTTON_COLOR = '#0064E1';
export var STUDENT_DASHBOARD_ACCOUNT_MANAGER_TITLE_COLOR = '#565F76';
export var STUDENT_DASHBOARD_DOT_COLOR = '#A4ACC2';
export var PILL_BORDER = _STAR_DUST;
export var PILL_SELECTED_BORDER = _SCIENCE_BLUE;
export var PILL_TEXT = _TUNA;
export var PILL_SELECTED_TEXT = _SCIENCE_BLUE;
export var PILL_SELECTED_BACKGROUND = _LINK_WATER;
export var SELECTED_TAB_BORDER = _SCIENCE_BLUE;
export var BUTTON_CAD = '#FB2F3F';
export var BUTTON_USD = '#0064E1';
export var BUTTON_GBP = '#EA8400';
export var BUTTON_AUD = '#8CCA3A';
export var BUTTON_EUR = '#783ACA';
export var INPUT_ERROR_BORDER_COLOR = '#C82C41';